//this file switches between Nav 3 and Nav 4 page-layout components. When Nav 4 is at 100% this file can simply be deleted and index can export nav 4 directly instead
import React from 'react';
import type { FC } from 'react';

import { useIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/useIsNav4Enabled';

import type { PageLayoutProps } from './PageLayoutTypes';
import { Nav4Layout } from './Nav4Layout';
import { Nav3Layout } from './Nav3Layout';

export const PageLayout: FC<PageLayoutProps> = (props) => {
	const isNav4Enabled = useIsNav4Enabled();
	return isNav4Enabled ? <Nav4Layout {...props} /> : <Nav3Layout {...props} />;
};
